import React from "react";
import TransactionView from "../../../transactions/view";
import { useParams } from "react-router-dom";
import { FilterEntityEnum } from "@propertelligent/client-api";

interface TransactionTabContentProps {
  result: any[];
  entityTypeId?: FilterEntityEnum;
  isContractor?: boolean;
  contractorPayeeAccountNames?: any;
}

const TransactionTabContent: React.FC<TransactionTabContentProps> = ({ result, entityTypeId, isContractor = false, contractorPayeeAccountNames }) => {

  const { id } = useParams();
  return (

    isContractor ? (
      <TransactionView
        isContractor={true}
        contractorPayeeAccountNames={contractorPayeeAccountNames}
        isEntity={true}
        entityId={id ? parseInt(id) : undefined}
        entityTypeId={entityTypeId}
      />
    ) : (
      <TransactionView
        isEntity={true}
        entityId={id ? parseInt(id) : undefined}
        entityTypeId={entityTypeId}
      />
    )

  )
}


export default TransactionTabContent;
